export class Cookiespage {
    tekst!: string;
    foto1!: string;
    foto2!: string;
}
